<template>
  <div class="new-annouce-inner">
    <div class="annouce-left">
      <span class="title">最新公告</span>
      <div class="annouce-all">
        <div v-for="(v, index) in homeAnnouncementList" class="item" :key="v.afficheId">
          <div class="info"><span @click="itemClick(v.afficheId)">{{index + 1}}、{{v.afficheTitle}}</span></div>
        </div>
      </div>
    </div>
    <span class="toMore" v-if="homeAnnouncementList.length > 0" @click="goAnnounceMore">更多></span>
    <span class="empty" v-if="homeAnnouncementList.length === 0">暂无</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "announcement",
  computed: {
    ...mapState(['homeAnnouncementList']),
  },
  async created() {
    this.$store.dispatch('getHomeAfficheList')
  },
  methods: {
    goAnnounceMore() {
      this.$emit('setMainContent', {component: 'AnnounceList'})
    },
    itemClick (id) {
      this.$emit('setMainContent', {component: 'AnnounceDetails', afficheId:id})
    }
  }
}
</script>

<style lang="scss" scoped>
.new-annouce-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px;
  background: #ffffff;
  .annouce-left {
    display: flex;
    align-items: center;
    width: calc(100% - 36px);
    .title {
      font-family: MicrosoftYaHei, PingFangSC-Semibold, PingFang SC;
      font-size: 14px;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
      flex-shrink: 0;
      margin-right: 40px;
    }
    .annouce-all {
      width: calc(100% - 102px);
      display: flex;
      align-items: center;
      .item {
        width: 33%;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #333;
        line-height: 24px;
        flex-shrink: 0;
        padding-right: 40px;
        .info {
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          span {
            cursor: pointer;
          }
        }
        .info span:hover {
          color: #1C7AE5;
          text-decoration:underline;
        }
      }
    }
  }

  .toMore {
    font-family: MicrosoftYaHei;
    font-size: 13px;
    color: #1C7AE5;
    cursor: pointer;
  }
  .empty {
    font-family: MicrosoftYaHei;
    font-size: 13px;
    color: #666666;
    cursor: pointer;
  }
}
</style>
